import IMask from 'imask';
import Cart from '../cart/cart';

export default new class Input {
    constructor() {
        this.sPlusMinusInputWraperClass = '_input-wraper';
        this.sPlusMinusInputClass = '_input-plus-minus';
        this.sPlusClass = '_input-plus';
        this.sMinusClass = '_input-minus';

        this.sPhoneInputClass = '[name="phone"]';

        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        //маска для номера телефона
        this.initPhoneMask();

        let _this = this;

        //count input
        document.body.addEventListener("click", function (e) {
            if (e.target && e.target.classList.contains(`${_this.sPlusClass}`)) {
                _this.plusChange(e);
            }
        });
        document.body.addEventListener("click", function (e) {
            if (e.target && e.target.classList.contains(`${_this.sMinusClass}`)) {
                _this.minusChange(e);
            }
        });
    }

    plusChange(obEvent) {
        let input = obEvent.target.closest(`.${this.sPlusMinusInputWraperClass}`).querySelector(`.${this.sPlusMinusInputClass}`);
        let value = parseInt(input.value) + 1;
        let max = parseInt(input.getAttribute('data-max'));

        if(value <= max) {
            input.value = value;
            Cart.cartUpdate();
        }
    }

    minusChange(obEvent) {
        let input = obEvent.target.closest(`.${this.sPlusMinusInputWraperClass}`).querySelector(`.${this.sPlusMinusInputClass}`);
        let value = parseInt(input.value) - 1;
        let min = parseInt(input.getAttribute('data-min'));

        if(value >= min) {
            input.value = value;
            Cart.cartUpdate();
        }
    }

    initPhoneMask() {
        document.querySelectorAll(`${this.sPhoneInputClass}`).forEach((el) => {
            let mask = IMask(
                el,
                { mask: '+{7}-000-000-00-00', /*lazy: false, placeholderChar: 'X'*/}
            );
        });
    }
}();